import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { memo, useCallback, useEffect, useState } from 'react';
import classNames from 'classnames/bind';
import { Modal, Text } from '@beef/ui-kit';
import { defaultActiveLocale } from "../../constants";
import { Flag } from "./components/Flag";
import { Country } from "./components/Country";
import style from "./styles.module.pcss";
var cn = classNames.bind(style);
export var Countries = /*#__PURE__*/memo(function (_ref) {
  var international = _ref.international;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    modalIsOpen = _useState2[0],
    setModalIsOpen = _useState2[1];
  var _useState3 = useState(international.locales.find(function (locale) {
      return locale.icon === 'ru';
    })),
    _useState4 = _slicedToArray(_useState3, 2),
    activeLocale = _useState4[0],
    setActiveLocale = _useState4[1];
  var _useState5 = useState('RU'),
    _useState6 = _slicedToArray(_useState5, 2),
    lang = _useState6[0],
    setLang = _useState6[1];
  var changeVisibleModal = useCallback(function () {
    return setModalIsOpen(function (visible) {
      return !visible;
    });
  }, []);
  useEffect(function () {
    var _window, _window$location;
    if (window && (_window = window) !== null && _window !== void 0 && (_window$location = _window.location) !== null && _window$location !== void 0 && _window$location.href.includes('en-us')) {
      setActiveLocale(international.locales.find(function (locale) {
        return locale.icon === 'gb';
      }));
      setLang('EN');
    }
  }, [international]);
  return /*#__PURE__*/React.createElement("div", {
    className: cn('countries')
  }, /*#__PURE__*/React.createElement("button", {
    className: cn('country'),
    onClick: changeVisibleModal,
    type: "button"
  }, /*#__PURE__*/React.createElement(Flag, {
    srcIcon: (activeLocale === null || activeLocale === void 0 ? void 0 : activeLocale.srcIcon) || defaultActiveLocale.srcIcon
  }), /*#__PURE__*/React.createElement(Text, {
    size: "size5-m"
  }, lang)), /*#__PURE__*/React.createElement(Modal, {
    isOpen: modalIsOpen,
    onClose: changeVisibleModal,
    size: "s"
  }, /*#__PURE__*/React.createElement("div", {
    className: cn('international-wrapper')
  }, international.locales.map(function (locale) {
    return /*#__PURE__*/React.createElement(Country, {
      isActive: (activeLocale === null || activeLocale === void 0 ? void 0 : activeLocale.icon) === locale.icon,
      key: locale.title,
      lang: locale.title,
      link: locale.link,
      srcIcon: locale.srcIcon
    });
  })), /*#__PURE__*/React.createElement(Text, {
    className: cn('international-text'),
    size: "size4-m",
    tagType: "h3"
  }, international.beelineOtherCountries), /*#__PURE__*/React.createElement("div", {
    className: cn('international-wrapper')
  }, international.countries.map(function (country) {
    return /*#__PURE__*/React.createElement(Country, {
      isActive: (activeLocale === null || activeLocale === void 0 ? void 0 : activeLocale.icon) === country.icon,
      isTargetBlank: true,
      key: country.title,
      lang: country.title,
      link: country.link,
      srcIcon: country.srcIcon
    });
  }))));
});